import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import RecoverModal from '../../../components/modals/recoverModal';
import DeleteModal from '../../../components/modals/deleteModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';

import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, trailBalanceFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { Space, Input, Tag, Button, Divider, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function CashFlow(props) {

  let { type, isDebit } = props;

  const { api, userData, settingData, yearId, companyId, secondaryCurrency, mainCurrency, refData, branchOptions, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [selectedBranch, setSelectedBranch] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [currency, setCurrency] = useState('main');
  const createdBy = parseInt(userData.id);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dataArray = ['branch']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const today = new Date().toISOString().split('T')[0];

  const [getCashFlow, setGetCashFlow] = useState(0);

  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: today, toDate: today });

  //change Type
  useEffect(() => {
    getCashFlowData();
  }, [filter, selectedBranch]);

  const getCashFlowData = async () => {
    try {  
      setIsLoading(true);
      const data = {
        companyId,
        yearId,
        fromDate: filter.fromDate,
        toDate: filter.toDate,
        branchId: selectedBranch?.value,
      }
      let res = await api.get(`cashFlow/getAll`, { params: data });

      if (res.data.status) {
        setGetCashFlow(res?.data?.getCashFlow)
      } else {
        toast.error(res?.data?.status);
      }
    } catch (error) {
      toast.error("Failed Contact Support");
    } finally {
      setIsLoading(false);
    }
  }

  const changeCurrency = (e) => {
    const value = e.target.value;
    setFilter((prevFilter) => ({
      ...prevFilter,
      currency: value,
    }));
  }



  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>

          <Row className='g-2 mb-3'>

            <Col md={3}>

            </Col>

            <Col md={3}>
              <DatePicker setFilter={setFilter} filter={filter} />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={branchOptions}
                isSearchable={true}
                isClearable={true}
                placeholder="Select Branch"
                onChange={setSelectedBranch}
                value={selectedBranch}
                required
              />
            </Col>

            <Col md={1}>
              <Form.Select size="sm" onChange={e => setCurrency(e.target.value)} value={currency}>
                <option value={'main'}>{mainCurrency.code}</option>
                <option value={'secondary'}>{secondaryCurrency.code}</option>
              </Form.Select>
            </Col>

            <Col md={1}>
            </Col>


            <Col md={2} className="d-flex justify-content-end">
              <Button >
                <FiPrinter size={18} />
              </Button>
              <Button onClick={getCashFlowData}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>


            {currency == 'main' &&


              <Card title={contentLanguages.CashFlow} bordered={false} style={{ width: '60%' }} headStyle={{ textAlign: 'center' }}>

                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.SalesRevenue}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.salesBalance)}
                  </Col>
                </Row>



                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.Receipt}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.receiptBalance)}
                  </Col>
                </Row>


                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.PurchaseReturn}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.purchaseReturnBalance)}
                  </Col>
                </Row>


                <Divider />

                <Row className='mb-5'>
                  <Col md={1}>
                  </Col>
                  <Col md={9} style={{ fontWeight: 'bold' }}>
                    {contentLanguages.InFlow}:
                  </Col>
                  <Col md={2} style={{ fontWeight: 'bold' }}>
                    {numberFormatter(getCashFlow?.inFlows)}
                  </Col>
                </Row>



                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.Purchases}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.purchaseBalance)}
                  </Col>
                </Row>


                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.Expenses}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.expenseBalance)}
                  </Col>
                </Row>



                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.Payments}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.paymentBalance)}
                  </Col>
                </Row>

                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.SalesReturn}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.salesReturnBalance)}
                  </Col>
                </Row>


                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.CashVariance}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.varianceBalance)}
                  </Col>
                </Row>


                <Divider />

                <Row className='mb-5'>
                  <Col md={1}>
                  </Col>
                  <Col md={9} style={{ fontWeight: 'bold' }}>
                    {contentLanguages.OutFlow}:
                  </Col>
                  <Col md={2} style={{ fontWeight: 'bold' }}>
                    {numberFormatter(getCashFlow?.outFlows)}
                  </Col>
                </Row>



                <Row className='mb-5'>
                  <Col md={1}>
                  </Col>
                  <Col md={9} style={{ fontWeight: 'bold', color: 'green' }}>
                    {contentLanguages.CashBalance}:
                  </Col>
                  <Col md={2} style={{ fontWeight: 'bold', color: 'green' }}>
                    {numberFormatter(getCashFlow?.inFlows - getCashFlow?.outFlows)}
                  </Col>
                </Row>




              </Card>
            }

            {currency == 'secondary' &&


              <Card title="Cash Flow" bordered={false} style={{ width: '60%' }} headStyle={{ textAlign: 'center' }}>

                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.SalesRevenue}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.salesSecondarybalance)}
                  </Col>
                </Row>



                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.Receipt}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.receiptSecondarybalance)}
                  </Col>
                </Row>


                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.PurchaseReturn}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.secondaryPurchaseReturnBalance)}
                  </Col>
                </Row>


                <Divider />

                <Row className='mb-5'>
                  <Col md={1}>
                  </Col>
                  <Col md={9} style={{ fontWeight: 'bold' }}>
                    {contentLanguages.InFlow}:
                  </Col>
                  <Col md={2} style={{ fontWeight: 'bold' }}>
                    {numberFormatter(getCashFlow?.secondaryInFlows)}
                  </Col>
                </Row>



                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.Purchases}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.purchaseSecondarybalance)}
                  </Col>
                </Row>


                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.Expenses}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.expenseSecondarybalance)}
                  </Col>
                </Row>



                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.Payments}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.paymentSecondarybalance)}
                  </Col>
                </Row>

                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.SalesReturn}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.salesReturnSecondarybalance)}
                  </Col>
                </Row>


                <Row>
                  <Col md={1}>
                  </Col>
                  <Col md={9}>
                    {contentLanguages.CashVariance}:
                  </Col>
                  <Col md={2}>
                    {numberFormatter(getCashFlow?.varianceSecondarybalance)}
                  </Col>
                </Row>


                <Divider />

                <Row className='mb-5'>
                  <Col md={1}>
                  </Col>
                  <Col md={9} style={{ fontWeight: 'bold' }}>
                    {contentLanguages.OutFlow}:
                  </Col>
                  <Col md={2} style={{ fontWeight: 'bold' }}>
                    {numberFormatter(getCashFlow?.secondaryOutFlows)}
                  </Col>
                </Row>



                <Row className='mb-5'>
                  <Col md={1}>
                  </Col>
                  <Col md={9} style={{ fontWeight: 'bold', color: 'green' }}>
                    {contentLanguages.CashBalance}:
                  </Col>
                  <Col md={2} style={{ fontWeight: 'bold', color: 'green' }}>
                    {numberFormatter(getCashFlow?.secondaryInFlows - getCashFlow?.secondaryOutFlows)}
                  </Col>
                </Row>




              </Card>
            }


          </div>

        </div>
      }


    </div>
  )
}

export default CashFlow;
